// externals
import type { FC } from 'react';
import { nanoid } from 'nanoid';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';

// libraries
import { SelectInput } from '@interstate/components/SelectInput';
import { dealerSelectors } from '@makemydeal/dr-shared-store';

// interfaces/types
import type { ColumnMapping, SelectInputChangeInterstateEventHandler } from '../manualAccessoriesTypes';

// consts/enums
import { PROFIT } from '../../../constants';
import { profitOptions } from '../manualAccessoriesConsts';
import type { BaseDealBreakpoint } from '../../../types';

export type ManualAccessoryProfitFieldStateProps = {
    disabled: boolean;
    index: number;
    profit: string | undefined;
    profitColumnMapping: ColumnMapping<string>;
    baseBreakPoint: BaseDealBreakpoint;
};

export type ManualAccessoryProfitFieldDispatchProps = {
    handleInputChange: SelectInputChangeInterstateEventHandler;
};

export type ManualAccessoryProfitFieldProps = ManualAccessoryProfitFieldDispatchProps & ManualAccessoryProfitFieldStateProps;

export const ManualAccessoryProfitField: FC<ManualAccessoryProfitFieldProps> = ({
    disabled,
    index,
    profit,
    profitColumnMapping,
    handleInputChange,
    baseBreakPoint
}) => {
    const uniqueId = nanoid();

    const isSmallScreenSize = useMediaQuery({ query: `(max-width: ${baseBreakPoint.TABLET_PORTRAIT})` });
    const isDealCentralExperience = useSelector(dealerSelectors.isDealCentralExperience);
    const displayProfitLabel = isDealCentralExperience && isSmallScreenSize;

    return (
        <SelectInput
            size="sm"
            label={PROFIT}
            displayLabel={displayProfitLabel}
            data-testid={`${profitColumnMapping.fieldName}-${index}`}
            displayDeselectOption={false}
            onChange={(e) => {
                handleInputChange(e, profitColumnMapping.fieldName);
            }}
            name={`${profitColumnMapping.fieldName}-${index}`}
            options={profitOptions}
            value={profit}
            required={false}
            disabled={disabled}
            id={`base-accessories-profit-field-${index}-${uniqueId}`}
            sx={displayProfitLabel ? {} : { marginTop: '0.5625rem' }}
        />
    );
};
